import React from "react";
import { SUPPORTED_LANGUAGES, normalizeLanguage } from "../../utils/i18n";

export default function LanguageToggle({
  language = "en",
  onChange = () => {},
  label = "Language",
  compact = false,
}) {
  const selectedLanguage = normalizeLanguage(language);

  return (
    <div style={styles.wrap}>
      {!compact ? <span style={styles.label}>{label}</span> : null}
      <div style={styles.segmented}>
        {SUPPORTED_LANGUAGES.map((item) => {
          const active = selectedLanguage === item.value;
          return (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange(item.value)}
              style={{
                ...styles.button,
                ...(active ? styles.buttonActive : {}),
              }}
              aria-pressed={active}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    flexWrap: "wrap",
    margin: "10px 0 14px",
  },
  label: {
    color: "#475569",
    fontSize: 13,
    fontWeight: 900,
  },
  segmented: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    padding: 4,
    borderRadius: 999,
    background: "#eef6ff",
    border: "1px solid rgba(191,219,254,0.95)",
    boxSizing: "border-box",
    maxWidth: "100%",
  },
  button: {
    minHeight: 36,
    border: 0,
    borderRadius: 999,
    padding: "8px 12px",
    background: "transparent",
    color: "#475569",
    fontWeight: 900,
    cursor: "pointer",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
  },
  buttonActive: {
    background: "linear-gradient(135deg, #0f6fff, #10b981)",
    color: "#ffffff",
    boxShadow: "0 8px 18px rgba(15,111,255,0.22)",
  },
};
